export const VIEWER_MODES = {
	FULL: "full",
	QR: "qr",
};
